import {camelToSnake} from "./CaseTransformer.js";
import {stateNamesByAbbreviation} from "../constants/States.js";

export const locationFields = ["city", "state", "lat", "lng", "country", "postalCode", "addressLine1", "addressLine2"];
const normalize = value => String(value ?? "").trim().toLowerCase();
export const candidateStateName = value => stateNamesByAbbreviation[String(value ?? "").trim().toUpperCase()] ?? String(value ?? "").trim();
const normalizeCountry = value => ["us", "usa", "united states", "united states of america"].includes(normalize(value)) ? "us" : normalize(value);
export const validCoordinatePair = value => [value?.lat, value?.lng].every(v => v !== null && v !== undefined && v !== "" && Number.isFinite(Number(v)))
  && Math.abs(Number(value.lat)) <= 90 && Math.abs(Number(value.lng)) <= 180;
export const locationTuple = value => Object.fromEntries(locationFields.map(key => [key,
  value?.[key] ?? value?.[camelToSnake(key)] ?? (["lat", "lng"].includes(key) ? null : ""),
]));

/** Resume suggestions may fill gaps, but existing answers remain authoritative. */
export const mergeResumeLocation = (current, proposal) => {
  const existing = locationTuple(current);
  const proposed = locationTuple(proposal);
  const conflict = ["city", "state", "country"].some(key => {
    const normalized = key === "country" ? normalizeCountry : key === "state" ? value => normalize(candidateStateName(value)) : normalize;
    return normalized(existing[key]) && normalized(proposed[key]) && normalized(existing[key]) !== normalized(proposed[key]);
  });
  if (conflict) return existing;
  const merged = Object.fromEntries(locationFields.map(key => [key, existing[key] || proposed[key] || ""]));
  merged.lat = existing.lat;
  merged.lng = existing.lng;
  if (!validCoordinatePair(existing)) {
    const canLocate = normalize(proposal?.city) && normalize(proposal?.state) && validCoordinatePair(proposal);
    merged.lat = canLocate ? Number(proposal.lat) : null;
    merged.lng = canLocate ? Number(proposal.lng) : null;
  }
  return merged;
};
